import styled from 'styled-components';
import { COLORS } from '@app/constants/STYLES';

export const HeaderSearchSection = styled.div`
  position: relative;
`;

export const InputWrapper = styled.div<{ $isDarkMode: boolean }>`
  box-sizing: border-box;
  padding: 0 12px;
  border-radius: 12px;
  width: 214px;
  height: 36px;
  overflow: hidden;
  background-color: ${({ $isDarkMode }) =>
    $isDarkMode ? 'rgba(31, 31, 31, 1)' : 'rgba(255, 255, 255, 0.5)'};

  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  background-color: transparent;
`;

export const IconWrapper = styled.div`
  min-width: 20px;
  height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
`;
